import { EventJournalQueries } from '@entities/eventJournal/model/queries';

const escapeRe = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Преобразует query-строку:
 * authors=1,2  -> authors[]=1&authors[]=2
 * estimate=10,20 -> estimate[]=10&estimate[]=20
 * type=a,b      -> type[]=a&type[]=b
 *
 * Остальные параметры не трогаем и сохраняем порядок.
 * Реализация без явного цикла (используем String.replace с RegExp).
 */
export function queryParamsAdapterToRequest(
    query: string,
    arrayKeys: string[] = [
        EventJournalQueries.authors,
        EventJournalQueries.estimate,
        EventJournalQueries.type,
    ]
): string {
    const qs = query.startsWith('?') ? query.slice(1) : query;
    if (!qs) return '';

    const keysAlt = arrayKeys.map(escapeRe).join('|');

    const re = new RegExp(`(^|&)(${keysAlt})=([^&]*)`, 'g');

    const adapted = qs.replace(re, (_match, sep: string, key: string, rawVal: string) => {
        if (rawVal === '') return `${sep}${key}=`;

        const expanded = decodeURIComponent(rawVal)
            .split(',')
            .filter((v) => v !== '')
            .map((v) => `${encodeURIComponent(key)}[]=${encodeURIComponent(v)}`)
            .join('&');

        return `${sep}${expanded}`;
    });

    return adapted;
}
